import GMAIL_AUTH_URL from "../../graphql/companyProfile/GetAuthGmailUrl.gql";
import UPDATE_PROFILE_COMPANY_ADD_MAIL from "../../graphql/UpdateProfileCompanyAddMail.gql";
import UPDATE_PROFILE_COMPANY_UPDATE_MAIL from "../../graphql/UpdateProfileCompanyUpdateMail.gql";

import { emailPattern } from "../../services/emailServices";
import { Component, Vue } from "vue-facing-decorator";
import { Prop, Model } from "vue-facing-decorator";
import { Watch } from "vue-facing-decorator";

@Component({
    emits: ["input", "currentStep", "displayValid", "onUpdate"],
})
export class AccountingConfigAPIBase extends Vue {
    @Model() value: boolean;
    @Prop() config: any;
    // @Prop({ default: "Client" }) mode: string
    @Prop({ default: "" }) companyId: string;
    @Prop({ default: "" }) profileId: string;
    @Prop({ default: "" }) mailUsage: string;
    @Prop({ default: -1 }) index: number;
    @Prop({ default: undefined }) forMyCompany: boolean;

    get dialog() {
        return this.value;
    }

    set dialog(event) {
        if (!event) {
            this.windowStep = "default";
        }
        this.value = event;
    }

    get type() {
        return this.mailUsage;
    }

    set type(event) {
        debugger;
        // this.$emit("input", event);
    }

    windowStep = "default";

    connectToAccountingMailLoading = false;
    connectToDocumentFromMailLoading = false;

    valid = false;
    loading = false;
    errorCredentials = false;
    errorCredentials2 = false;

    email = "";
    host = "";
    hostDisabled = true;
    password = "";
    show = false;
    port = 993;
    portDisabled = true;

    listHostsImap = [
        "outlook.office365.com",
        "imap.mail.me.com",
        "imap.mail.yahoo.com",
        "ssl0.ovh.net",
        "imap.zoho.eu",
        "imap.free.fr",
        "imap.sfr.fr",
        "imap.orange.fr",
        "imap.laposte.net",
        "mail.gandi.net",
    ]; //'imap-mail.outlook.com',
    listHostsSmtp = [
        "smtp.office365.com",
        "smtp.live.com",
        "smtp.mail.me.com",
        "smtp.mail.yahoo.com",
        "ssl0.ovh.net",
        "smtp.zoho.eu",
        "smtp.free.fr",
        "smtp.sfr.fr",
        "smtp.orange.fr",
        "smtp.laposte.net",
        "mail.gandi.net",
    ]; //'smtp-mail.outlook.com',

    get rules() {
        return {
            isEmail: (value) => {
                return emailPattern.test(value) || "E-mail invalide";
            },
            notAlreadyUsedMail: (value) => {
                if (this.type === "accountingMail") {
                    const found = this.config.accountingMailConfig.users.find(
                        (el) => el.email === value,
                    );
                    return found == undefined || "E-mail déjà utilisé";
                } else if (this.type === "documentFromMail") {
                    const found = this.config.documentFromMailConfig.users.find(
                        (el) => el.email === value,
                    );
                    if (found) {
                        if (!!found.forMyCompany === this.forMyCompany) {
                            return "E-mail déjà utilisé";
                        }
                        return this.forMyCompany
                            ? "E-mail déjà utilisé pour la récupération des factures de vos clients (dans la GI)"
                            : "E-mail déjà utilisé pour la récupération de vos factures (dans la partie production)";
                    }
                    return found == undefined || "E-mail déjà utilisé";
                } else if (this.type === "sendingMail") {
                    const found = this.config.sendingMailSMTPConfig.users.find(
                        (el) => el.email === value,
                    );
                    return found == undefined || "E-mail déjà utilisé";
                } else {
                    debugger;
                }
            },
            notEmpty: (value) => {
                return !!value || "A remplir";
            },
        };
    }

    get specialErrorMessage() {
        if (this.host === "imap.mail.yahoo.com" || this.host === "smtp.mail.yahoo.com") {
            return "Dans le cas d'un compte yahoo, pensez à générer et utiliser le MOT DE PASSE D'APPLICATION pour bobbee (à créer dans vos paramètres yahoo)";
            // } else if (this.host === "outlook.office365.com" || this.host === "smtp.office365.com") {
            //     return "Dans le cas d'un compte outlook ou microsoft (surtout un compte pro), pensez à activer l'autorisation dans vos paramètres (on vous montre comment faire <a href=\"https://kinsta.com/fr/base-de-connaissances/office-365-smtp/#1-activer-lauthentification-smtp-dans-microsoft-365\">ici</a>)";
        }
        return "";
    }

    @Watch("windowStep")
    windowModification() {
        this.$emit("currentStep", this.windowStep);
        if (this.windowStep === "notGmailVue") {
            this.adaptPort();
        } else {
            this.reinitializeCredentials();
            this.dialog = false;
        }
    }

    @Watch("valid")
    emitValid() {
        this.$emit("displayValid", this.valid);
    }

    @Watch("host") // have to do because @change in combobox doesn't work
    adaptPortToHost() {
        this.adaptPort();
    }

    adaptPort() {
        if (this.type === "sendingMail") {
            if (
                this.host === "smtp-mail.outlook.com" ||
                this.host === "smtp.office365.com" ||
                this.host === "smtp.live.com"
            ) {
                this.port = 587;
            } else {
                this.port = 465;
            }
        } else {
            this.port = 993;
        }
    }

    async connectToAccountingMail() {
        this.connectToAccountingMailLoading = true;
        const {
            data: {
                getAuthGmailUrl: { url },
            },
        } = await this.$apollo.query({
            query: GMAIL_AUTH_URL,
            variables: {
                companyId: this.companyId,
                mailUsage: "AccountingMail",
                frontUrl: document.URL,
            },
        });
        this.connectToAccountingMailLoading = false;

        window.location.href = url;
    }

    async connectToDocumentFromMail() {
        this.connectToDocumentFromMailLoading = true;

        const {
            data: {
                getAuthGmailUrl: { url },
            },
        } = await this.$apollo.query({
            query: GMAIL_AUTH_URL,
            variables: {
                companyId: this.companyId,
                mailUsage: "DocumentFromMail",
                frontUrl: document.URL,
                forMyCompany: this.forMyCompany,
            },
        });
        this.connectToDocumentFromMailLoading = false;

        window.location.href = url;
    }

    adaptHostToEmail() {
        if (this.email) {
            const domainName = String(this.email.match(new RegExp(/(@.+)/gm)));
            if (this.mailUsage !== "sendingMail") {
                if (this.hostServerImapDico[domainName]) {
                    this.host = this.hostServerImapDico[domainName];
                } else if (
                    Object.keys(this.hostServerImapDico).find((e) => domainName.endsWith(e))
                ) {
                    this.host =
                        this.hostServerImapDico[
                            Object.keys(this.hostServerImapDico).find((e) => domainName.endsWith(e))
                        ];
                }
            } else {
                if (this.hostServerSMTPDico[domainName]) {
                    this.host = this.hostServerSMTPDico[domainName];
                    this.adaptPort();
                } else if (
                    Object.keys(this.hostServerSMTPDico).find((e) => domainName.endsWith(e))
                ) {
                    this.host =
                        this.hostServerSMTPDico[
                            Object.keys(this.hostServerSMTPDico).find((e) => domainName.endsWith(e))
                        ];
                    this.adaptPort();
                }
            }
        }
    }

    hostServerImapDico = {
        "@gmail.com": "imap.gmail.com",
        "@yahoo.com": "imap.mail.yahoo.com",
        "@yahoo.fr": "imap.mail.yahoo.com",
        "@hotmail.com": "outlook.office365.com",
        "@live.com": "outlook.office365.com",
        "@outlook.com": "outlook.office365.com",
        "@outlook.fr": "outlook.office365.com",
        "onmicrosoft.com": "outlook.office365.com",
        "@msn.com": "imap-mail.outlook.com",
        "@icloud.com": "imap.mail.me.com",
        "@me.com": "imap.mail.me.com",
        "@mac.com": "imap.mail.me.com",
        OVHcloud: "ssl0.ovh.net",
        "@zohomail.eu": "imap.zoho.eu",
        "@free.fr": "imap.free.fr",
        "@sfr.fr": "imap.sfr.fr",
        "@neuf.fr": "imap.sfr.fr",
        "@orange.fr": "imap.orange.fr",
        "@wanadoo.fr": "imap.orange.fr",
        "@laposte.net": "imap.laposte.net",
    };

    hostServerSMTPDico = {
        "@gmail.com": "smtp.gmail.com",
        "@yahoo.com": "smtp.mail.yahoo.com",
        "@yahoo.fr": "smtp.mail.yahoo.com",
        "@hotmail.com": "smtp.office365.com",
        "@hotmail.fr": "smtp.office365.com",
        "@live.com": "smtp.office365.com",
        "@outlook.com": "smtp.office365.com",
        "@outlook.fr": "smtp.office365.com",
        "onmicrosoft.com": "smtp.office365.com",
        "@msn.com": "smtp.office365.com",
        "@icloud.com": "smtp.mail.me.com",
        "@me.com": "smtp.mail.me.com",
        "@mac.com": "smtp.mail.me.com",
        OVHcloud: "ssl0.ovh.net",
        "@zohomail.eu": "smtp.zoho.eu",
        "@free.fr": "smtp.free.fr",
        "@sfr.fr": "smtp.sfr.fr",
        "@neuf.fr": "smtp.sfr.fr",
        "@orange.fr": "smtp.orange.fr",
        "@wanadoo.fr": "smtp.orange.fr",
        "@laposte.net": "smtp.laposte.net",
    };

    testAndCreationFromOutside() {
        this.testAndCreation(this.type);
    }

    async testAndCreation(type) {
        //login test is back side
        this.loading = true;
        const info = await this.$apollo.mutate({
            mutation: UPDATE_PROFILE_COMPANY_ADD_MAIL,
            variables: {
                companyId: this.companyId,
                type: type,
                accountingMailConfig: this.config.accountingMailConfig,
                documentFromMailConfig: this.config.documentFromMailConfig,
                sendingMailSMTPConfig: this.config.sendingMailSMTPConfig,
                credentials: {
                    email: this.email,
                    password: this.password,
                    host: this.host,
                    port: this.port,
                },
                forMyCompany: this.forMyCompany,
            },
        });
        this.loading = false;
        if (info.data.updateProfileCompanyAddMail.infoUpdate === "LOGIN failed") {
            // quand adresse mail inexistante -> ne renvoie pas forcément cette erreur
            this.errorCredentials = false;
            this.errorCredentials2 = true;
            return false;
        } else if (this.errorConnexion(info.data.updateProfileCompanyAddMail.infoUpdate)) {
            this.errorCredentials2 = false;
            this.errorCredentials = true;
            return false;
        } else {
            this.errorCredentials = false;
            this.errorCredentials2 = false;
            this.$emit("onUpdate");
            this.windowStep = "default";
            return true;
            // this.reinitializeCredentials()
            // this.vueEnterCredentialsNotGmail = false
        }
    }

    testAndModificationFromOutside() {
        this.testAndModification(this.type, this.index);
    }

    async testAndModification(type, index) {
        this.loading = true;
        const info = await this.$apollo.mutate({
            mutation: UPDATE_PROFILE_COMPANY_UPDATE_MAIL,
            variables: {
                profileId: this.profileId,
                type: type,
                accountingMailConfig: this.config.accountingMailConfig,
                documentFromMailConfig: this.config.documentFromMailConfig,
                sendingMailSMTPConfig: this.config.sendingMailSMTPConfig,
                index: index,
                password: this.password,
            },
        });
        if (this.errorConnexion(info.data.updateProfileCompanyUpdateMail.infoUpdate)) {
            this.errorCredentials = true;
        } else {
            this.errorCredentials = false;
            this.reinitializeCredentials();
            this.$emit("onUpdate");
            // this.dialog = false
        }
        this.loading = false;
    }

    errorConnexion(infoUpdate) {
        if (infoUpdate === this.profileId) {
            return false;
        }
        return true;
    }

    reinitializeCredentials() {
        this.type = "";
        this.valid = false;
        // this.validPassword = false
        this.loading = false;
        this.errorCredentials = false;

        // this.index = -1

        this.email = "";

        this.host = "";
        this.hostDisabled = true;

        this.password = "";
        this.show = false;

        this.port = 993;
        this.portDisabled = true;
    }
}
